import { useCallback } from 'react';
import { convertTeamsToOptions } from '../utils/convert-teams';
export const useConvertToTeamOptions = routingSource => useCallback(teams => convertTeamsToOptions(teams, 1, routingSource), [routingSource]);